import React, { ReactElement, useEffect, useState } from 'react'
import {
  alertError,
  alertSuccess,
  InputField,
  InputType,
} from '@one-tree/library'
import { patchGiftCard } from '../../../../helpers/APIHelper'
import { validateEmail } from '../../../../helpers/ValidationHelper'
import { IEditGiftCardProps } from '../../../../types/API'
import EditableTableRow from './EditableTableRow'

function EditPurchaserEmail(props: IEditGiftCardProps): ReactElement {
  const { giftCard, setGiftCard } = props

  const [email, setEmail] = useState(giftCard.purchaserEmail)
  const [error, setError] = useState(false)
  const [changeEmailReason, setChangeEmailReason] = useState('')
  const [emailIsEditing, setEmailIsEditing] = useState(false)
  const handleChangeEmail = async (): Promise<void> => {
    if (validateEmail(email)) {
      setError(true)
      alertError(validateEmail(email))
      return
    }
    setError(false)
    const result = await patchGiftCard({
      cardId: giftCard.id,
      patchOptions: {
        purchaserEmail: email,
        reason: changeEmailReason,
      },
    })
    if (result) {
      alertSuccess('Email updated')
      setEmail(result.purchaserEmail)
      setChangeEmailReason('')
      setEmailIsEditing(false)
      setGiftCard((p) => {
        if (p) return { ...p, ...result }
        return result
      })
    }
  }

  useEffect(() => {
    setEmail(giftCard.purchaserEmail)
  }, [giftCard.purchaserEmail])

  return (
    <EditableTableRow
      title="Purchaser email"
      isEditing={emailIsEditing}
      setIsEditing={setEmailIsEditing}
      editReason={changeEmailReason}
      setEditReason={setChangeEmailReason}
      saveAction={handleChangeEmail}
      cancelAction={(): void => {
        setChangeEmailReason('')
        setError(false)
        setEmail(giftCard.purchaserEmail)
      }}
    >
      <InputField
        placeholder="Add an email address..."
        type={InputType.Text}
        onChange={setEmail}
        value={email}
        isLong={true}
        isError={error}
      />
    </EditableTableRow>
  )
}
export default EditPurchaserEmail
